import { ADN_PLUS } from "./ADN_PLUS";
import { Condition } from "./Condition";
import { OperationParam, eConcatOption } from "./OperationParam";
import { OperationFile } from "./OperationFile";
import { EntityField } from "./EntityField";

export class ServicePlus {
    Entity: string;
    OperationName: string;
    Status: STATUS;
    Type: TYPE;
    Source: string;
    UserCode: string;
    Conditions: Condition;
    Data: ADN_PLUS[];
    Params: OperationParam[];
    Files: OperationFile[];

    constructor(entity: string, operationName: string, type: TYPE = TYPE.ENTITY) {
        this.Entity = entity;
        this.OperationName = operationName;
        this.Type = type;
        this.Data = new Array<ADN_PLUS>();
        this.Params = new Array<OperationParam>();
        this.UserCode = this.getUser();
        this.Source = this.getView();
        this.Conditions = null;
    }

    private getUser(): string {
        let userJson = localStorage.getItem("loggedUser");
        if (userJson && userJson != 'null') {
            let user = JSON.parse(userJson);
            if (user.ArrayEntities) {
                return user.ArrayEntities.List.find(x => {
                    return x.Name === ''
                        ? (x.Alias === 'USER_CODE') : (x.Name === 'USER_CODE');
                }).Value;
            }
        }
        return "SYSTEM";
    }

    private getView(): string {
        return localStorage.getItem("currentView");
    }


    public toString(): string {
        return "(" + this.Type + ") " + this.Entity + "." + this.OperationName + ": Data = [" + this.Data.length + "], Condition = " + (this.Conditions != null) + ", Validations = [" + this.Params.length + "]";
    }


    private OrderParamsByGroup(): OperationParam[] {
        return this.Params;
    }

    public getCondition(conditionName: string): EntityField {
        return this.Conditions ? this.Conditions.Data.find(x => x.Name == conditionName) : null;
    }

    public getDataElement(conditionName: string): EntityField {
        for (let adn of this.Data) {
            if (adn.getStringAttribute(conditionName)) {
                return adn.ArrayEntities.List.find(x => x.Name == conditionName);
            }
        }
    }
}

export enum TYPE { SERVICE = 0, ENTITY = 1 }
export enum STATUS { FAIL = 0, SUCCESS = 1 }
